import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { Process } from "@/components/Process";
import { PromoBanner } from "@/components/PromoBanner";
import { Gallery } from "@/components/Gallery";
import { FAQSection } from "@/components/FAQSection";
import { Contact } from "@/components/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <Services />
      <WhyUs />
      <Process />
      <Gallery />
      <PromoBanner />
      <FAQSection />
      <Contact />
    </>
  );
}
